"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var zIndex = 2008; // to be more than for regular modal
var _default = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _default, [].concat(args));
    _defineProperty(_this, "state", {
      opacity: 0,
      isConfirmAllowed: false,
      confirmError: ''
    });
    _defineProperty(_this, "_abort", function () {
      _this.props.promise.onReject();
    });
    _defineProperty(_this, "_confirm", function (confirmation) {
      if (!_this.state.isConfirmAllowed) {
        return;
      }
      _this.props.promise.onResolve(confirmation);
    });
    return _this;
  }
  _inherits(_default, _React$Component);
  return _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        opacity: 1,
        isConfirmAllowed: !this.props.confirmString
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        confirmError = _this$state.confirmError,
        opacity = _this$state.opacity,
        isConfirmAllowed = _this$state.isConfirmAllowed;
      var _this$props = this.props,
        abortLabel = _this$props.abortLabel,
        confirmLabel = _this$props.confirmLabel,
        confirmString = _this$props.confirmString,
        description = _this$props.description,
        message = _this$props.message;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].backdrop,
        style: {
          zIndex: zIndex
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].content,
        style: {
          zIndex: zIndex + 1,
          opacity: opacity
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].header
      }, /*#__PURE__*/_react["default"].createElement("h4", null, message), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this._abort,
        className: "btn-close",
        type: "button",
        "aria-label": "Close"
      })), (description || confirmString) && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].body
      }, description && /*#__PURE__*/_react["default"].createElement("div", null, description), confirmString && /*#__PURE__*/_react["default"].createElement("div", {
        className: "mt-3"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "mb-0"
      }, "Enter the following text to confirm:"), /*#__PURE__*/_react["default"].createElement("code", {
        className: "mb-1 rounded d-inline-block px-2 py-1 bg-body-secondary text-dark"
      }, confirmString), /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-control",
        id: "confirmString",
        onChange: function onChange(event) {
          var text = event.target.value;
          var err = '';
          if (text !== confirmString && text.toLowerCase() === confirmString.toLowerCase()) {
            err = 'Text is case-sensitive';
          }
          _this2.setState({
            isConfirmAllowed: text === confirmString,
            confirmError: err
          });
        }
      }), confirmError && /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-danger mt-1"
      }, confirmError))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].footer
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        onClick: this._abort
      }, abortLabel), this.props.additionalConfirmButtons.map(function (button) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          key: button.confirmation,
          type: "button",
          className: "btn btn-primary",
          style: {
            marginRight: '0.5em'
          },
          onClick: function onClick() {
            return _this2._confirm(button.confirmation);
          }
        }, button.confirmLabel);
      }), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: function onClick() {
          return _this2._confirm(_this2.props.confirmation);
        },
        disabled: !isConfirmAllowed
      }, confirmLabel))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(_default, "propTypes", {
  message: _propTypes["default"].node,
  description: _propTypes["default"].node,
  confirmLabel: _propTypes["default"].string,
  confirmString: _propTypes["default"].string,
  abortLabel: _propTypes["default"].string,
  promise: _propTypes["default"].object,
  additionalConfirmButtons: _propTypes["default"].array,
  confirmation: _propTypes["default"].string
});
_defineProperty(_default, "defaultProps", {
  message: 'Are you sure?',
  description: '',
  confirmLabel: 'Yes',
  abortLabel: 'No',
  additionalConfirmButtons: [],
  confirmation: null
});